export const planDetailsBannerContent = {
  ctaDataItemName: 'get-plan-top-cta',
}
